import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";

import { environment } from "@env/environment";
import { UrlBuilder } from "@app/shared/helpers";
import { NewsCreate } from "@app/shared/models/news/news-create.model";
import { NewsResponse } from "@app/shared/models/news/news-response.model";
import { NewsUpdate } from "@app/shared/models/news/news-update.model";

@Injectable({
  providedIn: 'root'
})
export class NewsService {
  private readonly http = inject(HttpClient);

  public getAllNews(): Observable<NewsResponse[]> {
    const url: string = UrlBuilder.create(environment.apiUrl)
      .addQuerySegments('news')
      .build();
    return this.http.get<NewsResponse[]>(url);
  }

  public getNewsById(id: number): Observable<NewsResponse> {
    const url: string = UrlBuilder.create(environment.apiUrl)
      .addQuerySegments('news', id.toString())
      .build();
    return this.http.get<NewsResponse>(url);
  }

  public updateNewsById(id: number, newsUpdate: NewsUpdate): Observable<NewsResponse> {
    const url: string = UrlBuilder.create(environment.apiUrl)
      .addQuerySegments('news', id.toString())
      .build();
    return this.http.put<NewsResponse>(url, newsUpdate);
  }

  public deleteNewsById(id: number): Observable<unknown> {
    const url: string = UrlBuilder.create(environment.apiUrl)
      .addQuerySegments('news', id.toString())
      .build();
    return this.http.delete(url);
  }

  public createNews(createNews: NewsCreate): Observable<NewsResponse> {
    const url: string = UrlBuilder.create(environment.apiUrl)
      .addQuerySegments('news')
      .build();
    return this.http.post<NewsResponse>(url, createNews);
  }
}
